import { Directive, Renderer2, HostListener, ElementRef } from '@angular/core';


export class DropdownDirective {
  active = false;
  stateCss = 'open';
  constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

  
  onDocHostClick($event) {
    const isContains = this.elementRef.nativeElement.contains($event.target);
    if (!isContains) {
      this.active = false;
      this.changeHostState();
    }
  }

  
  onHostClick() {
   this.toggleClass();
  }

  toggleClass() {
    this.active = !this.active;
    this.changeHostState();
  }

  changeHostState() {
    if (this.active) {
      this.renderer.addClass(this.elementRef.nativeElement, this.stateCss);
      return;
    }
    this.renderer.removeClass(this.elementRef.nativeElement, this.stateCss);
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[chDropdown]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onDocHostClick': [{ type: HostListener, args: ['document:click', ['$event'], ] },],
'onHostClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
